<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" class="ml-2 mr-2" variant="outline-secondary"
                style="font-size: 0.675rem">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="6">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.vesselNameFilter ||
              Filter.contractNoFilter ||
              Filter.containerTypeFilter ||
              Filter.slineFilter ||
              Filter.vesselVoyageNoFilter ||
              Filter.contractIdFilter ||
              Filter.PORFilter ||
              Filter.POLFilter ||
              Filter.PODFilter ||
              Filter.FPODFilter ||
              Filter.statusFilter ||
              Filter.commonFilter ||
              Filter.createdByFilter ||
              Filter.branchFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{

                Filter.vesselNameFilter ||
                  Filter.contractNoFilter ||
                  Filter.containerTypeFilter ||
                  Filter.slineFilter ||
                  Filter.vesselVoyageNoFilter ||
                  Filter.contractIdFilter ||
                  Filter.PORFilter ||
                  Filter.POLFilter ||
                  Filter.PODFilter ||
                  Filter.FPODFilter ||
                  Filter.statusFilter ||
                  Filter.commonFilter ||
                  Filter.createdByFilter ||
                  Filter.branchFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getContList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getContList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>

          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
          <b-col md="3">
            <label>Date</label>
            <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
              :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
              @update="getContractDashList('Normal', '0', '0', '1', '1')"></date-range-picker>
          </b-col>
          <b-col md="3">
            <label>Shipping Line</label>
            <model-list-select :list="$store.getters['common/getAllShippingLineList']" v-model="Filter.slineFilter"
              option-value="shippingId" option-text="shippingLine" placeholder="Select Shipping Line"
              @input="getContractDashList('Normal', '0', '0', '1', '1')"></model-list-select>
          </b-col>
          <b-col md="3">
            <label>Contract No Filter</label>
            <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Contract NO Filter"
              id="contractNoFilter" name="contractNoFilter" autocomplete="off" v-model="Filter.contractNoFilter"
              @input="getContractDashList('Normal', '0', '0', '1', '1')" />
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>

                <b-col md="3">
                  <label>Vessel Name Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Vessel Name Filter"
                    id="vesselNameFilter" name="vesselNameFilter" autocomplete="off" v-model="Filter.vesselNameFilter"
                    @input="getContractDashList('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Vessel Voyage No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Vessel Voyage No Filter"
                    id="vesselVoyageNoFilter" name="vesselVoyageNoFilter" autocomplete="off"
                    v-model="Filter.vesselVoyageNoFilter" @input="getContractDashList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <!-- <b-col md="3">
                  <label>Contract</label>
                  <model-list-select :list="shipmentTypeList" v-model="Filter.contractIdFilter" option-value="value"
                    option-text="value" placeholder="Select Contract"
                    @input="getContractDashList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col> -->

                <b-col md="3">
                  <label>Status</label>
                  <model-list-select :list="statusList" v-model="Filter.statusFilter" option-value="pTypeVal"
                    option-text="pTypeText" placeholder="Select Status"
                    @input="getContractDashList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Container Type</label>
                  <model-list-select :list="$store.getters['common/getAllContainerTypeList']" id="containerTypeFilter"
                    v-model="Filter.containerTypeFilter" option-value="containerTypeId" option-text="containerType"
                    placeholder="Select Container Type"
                    @input="getContractDashList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>POR</label>
                  <model-list-select :list="$store.getters['common/getAllPORList']" id="PORFilter"
                    v-model="Filter.PORFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getContractDashList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POL</label>
                  <model-list-select :list="$store.getters['common/getAllPOLList']" id="POLFilter"
                    v-model="Filter.POLFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getContractDashList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POD</label>
                  <model-list-select :list="$store.getters['common/getAllPODList']" id="PODFilter"
                    v-model="Filter.PODFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getContractDashList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>FPOD</label>
                  <model-list-select :list="$store.getters['common/getAllLocationDetailsFinalList']" id="FPODFilter"
                    v-model="Filter.FPODFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getContractDashList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                    @input="getContractDashList('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="getContractDashList('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName"
                    placeholder="Select Created User"></model-list-select>
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">

            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" responsive :items="getContList" :fields="contractFields"
                primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">


                <template slot="checkbox" slot-scope="row0">
                  <div class="d-flex align-items-center gap-2">
                    <b-button @click="row0.toggleDetails" class="mr-2" size="sm" style="font-size: 0.675rem"
                      variant="outline-info">
                      <md-icon>{{ row0.detailsShowing ? "expand_less" : "expand_more" }}</md-icon>
                      {{ row0.detailsShowing ? "Hide " : "Show " }} {{ row0.item.ContractNo }}

                    </b-button>

                  </div>
                </template>
                <template slot="SN" slot-scope="row0">
                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}
                  </span>
                </template>
                <template slot="containerTypes" slot-scope="row0">
                  <span>Container Type : {{ row0.item.containerTypes }}</span><br />
                  <span>{{ row0.item.totalContainerCountNo }}</span><br />
                  <span style="font-size: 0.675rem ;margin-left: 5px;color:blue">
                    {{ row0.item.totalTeusCountNo }}</span><br />
                  <!-- <span>Tot Container Count : {{ row0.item.containerCount }}</span><br />
                  <span style="font-size: 0.675rem ;margin-left: 5px;color:blue">Tot TEUS Count :
                    {{ row0.item.TeusTotCOunt }}</span><br /> -->
                  <!-- <span>Booking Nos : {{row0.item.bookingNos}}</span><br/>
                  <span>Job Nos : {{row0.item.JobNos}}</span><br/> -->
                </template>
                <template slot="BuyingRateTotalPerunit" slot-scope="row0">
                  ${{ row0.item.BuyingRateTotalPerunit }}
                </template>
                <template slot="BuyingPremiumRateTotalPerunit" slot-scope="row0">
                  ${{ row0.item.BuyingPremiumRateTotalPerunit }}
                </template>
                <!-- <template slot="SellingRateTotalPerunit" slot-scope="row0">
                  ${{ row0.item.SellingRateTotalPerunit }}
                </template> -->
                <template slot="totalSellRate" slot-scope="row0">
                  ${{ row0.item.totalSellRate }}
                </template>
                <template slot="totalTeusCountNo" slot-scope="row0">
                  <span style="color:blue" @click="getTesuWiseData(row0.item)">{{ row0.item.totalTeusCountNo }}</span><br />
                </template>

                <!-- Expandable Row for Additional Details -->

                <template slot="row-details" slot-scope="row4">
                  <b-card style="background: whiteSmoke">
                    <b-row>
                      <b-col md="12" class="mb-2"><b>Teus Wise:</b> {{ row4.item.totalTeusComma }}</b-col>
                      <b-col md="3" class="mb-2"><b>Contract ID:</b> {{ row4.item.ContractId }}</b-col>
                      <b-col md="3" class="mb-2"><b>Contract No:</b> {{ row4.item.ContractNo }}</b-col>
                      <b-col md="3" class="mb-2"><b>Vessel Name:</b> {{ row4.item.VesselName }}</b-col>
                      <b-col md="3" class="mb-2"><b>Vessel Voyage No:</b> {{ row4.item.VesselVoyageNo }}</b-col>
                      <b-col md="3" class="mb-2"><b>From:</b> {{ row4.item.From }}</b-col>
                      <b-col md="3" class="mb-2"><b>To:</b> {{ row4.item.To }}</b-col>
                      <b-col md="3" class="mb-2"><b>Buying Rate:</b> ${{ row4.item.BuyingRate }}</b-col>
                      <b-col md="3" class="mb-2"><b>Premium Buying Rate:</b> ${{ row4.item.BuyingPremiumRate }}</b-col>
                      <b-col md="3" class="mb-2"><b>Selling Rate:</b> ${{ row4.item.SellingRate }}</b-col>
                      <b-col md="3" class="mb-2"><b>Booking Nos:</b> {{ row4.item.bookingNo }}</b-col>
                      <!-- <b-col md="3" class="mb-2"><b>Enquiry Nos:</b> {{ row4.item.enquiryNos }}</b-col>
                      <b-col md="3" class="mb-2"><b>BRF Nos:</b> {{ row4.item.enquiryBookingNos }}</b-col> -->
                      <b-col md="3" class="mb-2"><b>Validity Start Date:</b> {{ row4.item.ValidityStartDate }}</b-col>
                      <b-col md="3" class="mb-2"><b>Validity End Date:</b> {{ row4.item.ValidityEndDate }}</b-col>
                      <b-col md="3" class="mb-2"><b>Start Date:</b> {{ row4.item.startDate }}</b-col>
                      <b-col md="3" class="mb-2"><b>End Date:</b> {{ row4.item.endDate }}</b-col>
                      <b-col md="3" class="mb-2"><b>Contract Create By:</b> {{ row4.item.ContractCreateBy }}</b-col>
                      <b-col md="3" class="mb-2"><b>Contract Create Date:</b> {{ row4.item.ContractCreateDate }}</b-col>
                      <b-col md="3" class="mb-2"><b>Create By:</b> {{ row4.item.CreateBy }}</b-col>
                      <b-col md="3" class="mb-2"><b>Create Date:</b> {{ row4.item.CreateDate }}</b-col>
                      <b-col md="3" class="mb-2"><b>Buying Rate Total Per unit:</b> ${{ row4.item.BuyingRateTotalPerunit
                      }}</b-col>
                      <b-col md="3" class="mb-2"><b>Buying Premium Rate Total Per unit:</b> ${{
                        row4.item.BuyingPremiumRateTotalPerunit }}</b-col>
                      <!-- <b-col md="3" class="mb-2"><b>Selling Rate Total Per unit:</b> ${{
                        row4.item.SellingRateTotalPerunit }}</b-col> -->
                        <b-col md="3" class="mb-2"><b>Selling Rate Total Per unit:</b> ${{
                        row4.item.totalSellRate }}</b-col>
                    </b-row>
                  </b-card>
                </template>


              </b-table>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <b-modal no-close-on-esc no-close-on-backdrop class="w-90" size="xl" ref="modal-Add-Open" hide-footer
      :title="'Container Wise Details'">
      <b-row>
        <b-col cols="12" class="mt-2">
          <b-table show-empty stacked="md" responsive :items="getTuesItem" :fields="tuesItemFields"
            primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" class="position-relative">
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 }}</span>
            </template>
            <template slot="BuyingRate" slot-scope="row0">
              ${{ row0.item.BuyingRate }}
            </template>
            <template slot="BuyingPremiumRate" slot-scope="row0">
              ${{ row0.item.BuyingPremiumRate }}
            </template>
            <template slot="SellingRate" slot-scope="row0">
              ${{ row0.item.SellingRate }}
            </template>
            <template slot="BuyingRateTotalPerunit" slot-scope="row0">
              ${{ row0.item.BuyingRateTotalPerunit }}
            </template>
            <template slot="BuyingPremiumRateTotalPerunit" slot-scope="row0">
              ${{ row0.item.BuyingPremiumRateTotalPerunit }}
            </template>
            <template slot="totalSellRate" slot-scope="row0">
              ${{ row0.item.totalSellRate }}
            </template>
            <!-- <template slot="SellingRateTotalPerunit" slot-scope="row0">
              ${{ row0.item.SellingRateTotalPerunit }}
            </template> -->
          </b-table>
        </b-col>
      </b-row>
    </b-modal>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat, excelSerialToDate } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import { read, utils, writeFile } from "xlsx";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    console.log(
      "this.$router.history.current.fullPath=>",
      this.$router.history.current.fullPath
    );

    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      ),
      this.$store.dispatch("common/setAllAgentColoaderList"),
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),
      this.$store.dispatch(
        "common/setAllLocationDetailsFinalList",
        JSON.stringify({ itemCode: "LocationDetailsFinalList" })
      ),
      this.$store.dispatch(
        "common/setAllPORList",
        JSON.stringify({ itemCode: "PORList" })
      ),
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({ itemCode: "PODList" })
      ),
      this.$store.dispatch(
        "common/setAllPOLList",
        JSON.stringify({ itemCode: "POLList" })
      ),

      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),
      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({
          itemCode: "ContainerTypeList",
        })
      ),
    ];
    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    // Wait for all store actions to complete
    Promise.all(storePromises)
      .then(() => delay(5000)) // Wait for 5 seconds
      .then(() => {
        // After the delay, execute the next function

      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getContractDashList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      getTuesItem: [],
      errMSG: "",
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getContList: [],
      totalData: 0,
      statusList: [
        {
          pTypeVal: "1",
          pTypeText: "Expired"
        },
        {
          pTypeVal: "0",
          pTypeText: "Not Expired"
        }

      ],

      validate: true,
      dateFormat: { year: "numeric", month: "short", day: "numeric" },
      tuesItemFields: [{
        key: "SN",
        mainkey: "SN",
        label: "SN.",
        sortable: true,
        sortDirection: "ASC",
        table: "A.",
      },
      {
        key: "VesselName",
        mainkey: "VesselName",
        label: "Vessel Name",
        sortable: true,
        sortDirection: "ASC",
        table: "E.",
      },
      {
        key: "VesselVoyageNo",
        mainkey: "VesselVoyageNo",
        label: "Voyage No",
        sortable: true,
        sortDirection: "ASC",
        table: "E.",
      },
      {
        key: "ContractNo",
        mainkey: "ContractNo",
        label: "Contract No",
        sortable: true,
        sortDirection: "ASC",
        table: "B.",
      },
      {
        key: "ContainerType",
        mainkey: "ContainerType",
        label: "Container Type",
        sortable: true,
        sortDirection: "ASC",
        table: "B.",
      },
      {
        key: "totalContainerCountNo",
        mainkey: "totalContainerCountNo",
        label: "Total Container",
        sortable: true,
        sortDirection: "ASC",
        table: "B.",
      },
      {
        key: "totalTeusCountNo",
        mainkey: "totalTeusCountNo",
        label: "Total TEUS",
        sortable: true,
        sortDirection: "ASC",
        table: "B.",
      },
      // {
      //   key: "totalContainers",
      //   mainkey: "totalContainers",
      //   label: "Total Container",
      //   sortable: true,
      //   sortDirection: "ASC",
      //   table: "B.",
      // },
      // {
      //   key: "TeusTotCOunt",
      //   mainkey: "TeusTotCOunt",
      //   label: "Total TEUS",
      //   sortable: true,
      //   sortDirection: "ASC",
      //   table: "B.",
      // },
      {
        key: "bookingNo",
        mainkey: "bookingNo",
        label: "Booking No",
        sortable: true,
        sortDirection: "ASC",
        table: "B.",
      },
      {
        key: "BuyingRate",
        mainkey: "BuyingRate",
        label: "Buying Rate",
        sortable: true,
        sortDirection: "ASC",
        table: "B.",
      },
      {
        key: "BuyingPremiumRate",
        mainkey: "BuyingPremiumRate",
        label: "Buying Premium Rate",
        sortable: true,
        sortDirection: "ASC",
        table: "B.",
      },
      {
        key: "SellingRate",
        mainkey: "SellingRate",
        label: "Selling Rate",
        sortable: true,
        sortDirection: "ASC",
        table: "B.",
      },
      {
        key: "BuyingPremiumRateTotalPerunit",
        mainkey: "BuyingPremiumRateTotalPerunit",
        label: "Buying Premium Rate",
        sortable: true,
        sortDirection: "ASC",
        table: "F.",
      },
      {
        key: "BuyingRateTotalPerunit",
        mainkey: "BuyingRateTotalPerunit",
        label: "Buying Rate",
        sortable: true,
        sortDirection: "ASC",
        table: "C.",
      },
      {
        key: "totalSellRate",
        mainkey: "totalSellRate",
        label: "Selling Rate",
        sortable: true,
        sortDirection: "ASC",
        table: "C.",
      },
      {
        key: "ValidityStartDate",
        mainkey: "ValidityStartDate",
        label: "Start Date",
        sortable: true,
        sortDirection: "ASC",
        table: "B.",
      },
      {
        key: "ValidityEndDate",
        mainkey: "ValidityEndDate",
        label: "End Date",
        sortable: true,
        sortDirection: "ASC",
        table: "B.",
      },
      ],
      contractFields: [
        {
          key: 'checkbox',   // Our custom field name for checkboxes
          mainkey: "checkbox",
          label: 'Select',         // No label, or you can put "Select"
          sortable: false,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "VesselName",
          mainkey: "VesselName",
          label: "Vessel Name",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "VesselVoyageNo",
          mainkey: "VesselVoyageNo",
          label: "Voyage No",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "ContractNo",
          mainkey: "ContractNo",
          label: "Contract No",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },

        {
          key: "Sline",
          mainkey: "Sline",
          label: "Shipping Line",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "containerTypes",
          mainkey: "containerTypes",
          label: "Container Type",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "totalContainerTypes",
          mainkey: "totalContainerTypes",
          label: "Total Container Type",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "totalContainerCountNo",
          mainkey: "totalContainerCountNo",
          label: "Total Container",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "totalTeusCountNo",
          mainkey: "totalTeusCountNo",
          label: "Total TEUS",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },

        {
          // key: "BuyingPremiumRate",
          // mainkey: "BuyingPremiumRate",
          key: "BuyingPremiumRateTotalPerunit",
          mainkey: "BuyingPremiumRateTotalPerunit",
          label: "Buying Premium Rate",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          // key: "BuyingRate",
          // mainkey: "BuyingRate",
          key: "BuyingRateTotalPerunit",
          mainkey: "BuyingRateTotalPerunit",
          label: "Buying Rate",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          // key: "SellingRate",
          // mainkey: "SellingRate",
          key: "totalSellRate",
          mainkey: "totalSellRate",
          label: "Selling Rate",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      Filter: {
        vesselNameFilter: "",
        contractNoFilter: "",
        containerTypeFilter: "",
        slineFilter: "",
        vesselVoyageNoFilter: "",
        contractIdFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "",
        commonFilter: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
      isSubmited: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {
    // If number of selected rows = total rows in getContList
    allSelected() {
      return this.selectedCheckBoxRows.length === this.getContList.length;
    }
  },
  watch: {},
  methods: {
    getTesuWiseData(item) {
      console.log("getTesuWiseData=>", item)

      this.getTuesItem = [];

      let payload = {
        // type: type,
        // DCfilterId: filterIdD,
        // searchVal: this.filter,
        // DCfilterId: filterIdD,
        // fromSearch: SEARCH,
        // // currentPage: CURRENT,
        // currentPage: this.pagination.currentPage,
        // page: this.pagination.currentPage,
        // perPage: this.pagination.perPage,
        // pageSize: this.pagination.perPage,
        // filter: this.Filter,
        // generateExcel: this.generateExcel,
        fk_cb_id: item.ContractId,
      };
      console.log("payload getTesuWiseData=>", payload)
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getContractMainDash(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data);
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              // Handle file download
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Sales-Payment-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.getContractDashList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.getTuesItem = data.data;
              }
            }
          }
          this.$refs["modal-Add-Open"].show();
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getContList Error: ", error);
        });
    },
    closeModal() {

      this.$refs["modal-Add-Open"].hide();
    },
    clearFilter() {
      this.Filter = {
        vesselNameFilter: "",
        contractNoFilter: "",
        containerTypeFilter: "",
        slineFilter: "",
        vesselVoyageNoFilter: "",
        contractIdFilter: "",
        PORFilter: "",
        POLFilter: "",
        PODFilter: "",
        FPODFilter: "",
        statusFilter: "",
        commonFilter: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getContractDashList("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    getContractDashList(type, filterIdD, CURRENT, SEARCH, pageNumber) {

      this.totalData = 0;
      this.getContList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
      };
      console.log("payload=>", payload)
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getContractMainDash(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data);
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              // Handle file download
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Sales-Payment-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.getContractDashList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.totalPaymentList;
                this.getContList = data.data;
                this.pagination.totalRows = data.pagination.total;
                this.pagination.currentPage = data.pagination.page;
                this.pagination.perPage = data.pagination.pageSize;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getContList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getContractDashList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getContractDashList("Excell", "0", "0", "1", "1");
    },

    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getContractDashList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      console.log("event=>", event);
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getContractDashList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>
<style>
.w-90 .modal-dialog {
  max-width: 90% !important;
  margin: 0 auto !important;
}
</style>


// WEBPACK FOOTER //
// vesselWiseContractDashboard.vue?13c44a72